class TriggerRestaurantDetails extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.prevent = false;
		this.options={
			'class': {
				'open': 'is-open'
			}
		}
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		this.$el.on('click', (e)=>this.handleDisplay(e));
		Me.dispatch.subscribe('restaurant-toolbox-closing', (e, params) => this.closeHandler(e, params));
		Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
	}

	removeEvents() {

	}

	handleDisplay(e){
		if(!this.prevent){
			return;
		}

		e.preventDefault();

		this.$el.toggleClass(this.options.class.open);
		Me.dispatch.emit('restaurant-toolbox', this);
	}

	closeHandler(e, params){
		this.$el.removeClass(this.options.class.open);
	}

	handleBreakpoints(e, params){
		this.prevent = (params.breakpoint !== '767-' && params.breakpoint !== '768-958');
	}
}